module.exports = __webpack_public_path__ + "static/media/deactivate.7bfbb0e3.svg";